import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  fetchCampaign,
  fetchCampaignSuccess,
  fetchCampaignFailure,
  getCampaign,
  getCampaignFailure,
  getCampaignSuccess,
  fetchInvolvedCampaigns,
  fetchInvolvedCampaignsSuccess,
  fetchInvolvedCampaignsFailure
} from './campaign.actions';
import { of } from 'rxjs';
import { map, mergeMap, catchError, tap } from 'rxjs/operators';
import { CampaignService } from '@services/campaign/campaign.service';

@Injectable()
export class CampaignEffects {
  loadCampaign$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchCampaign),
      mergeMap(action =>
        this.campaignService.getCampaigns(action.page, action.filterOptions).pipe(
          map(res => {
            return fetchCampaignSuccess({ campaign: res });
          }),
          catchError(error => {
            return of(fetchCampaignFailure({ error }));
          })
        )
      )
    )
  );

  getCampaign$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getCampaign),
      mergeMap(action => 
        this.campaignService.getCampaign(action.id).pipe(
          map(res => {
            return getCampaignSuccess({ campaign: res });
          }),
          catchError(error => {
            return of(getCampaignFailure({ error }));
          })
        )
      )
    )
  );

  loadInvolvedCampaigns$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchInvolvedCampaigns),
      mergeMap(action =>
        this.campaignService.getInvolvedCampaigns().pipe(
          map(res => {
            return fetchInvolvedCampaignsSuccess({ campaigns: res['data'] });
          }),
          catchError(error => {
            return of(fetchInvolvedCampaignsFailure({ error }));
          })
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private campaignService: CampaignService
  ) {}
}
